import React from 'react';
import AuthMethods from 'components/Account/AuthMethods';

export default function AuthenticationSection() {
  return (
    <>
      <AuthMethods />
    </>
  );
}
